/* ============================================================
   KLAVIYO — parches de convivencia con el banner de cookies
   Reescrito 23 ago 2026 para quitar un error que salia 13 veces
   por carga en TODAS las fichas de producto:
       TypeError: Cannot read properties of null (reading 'classList')

   QUE HACE:
     1. Esconde el teaser de Klaviyo en las fichas de producto.
     2. Esconde el modal de Klaviyo mientras el banner de cookies
        este visible (si no, se pisan).
     3. Quita la clase `klaviyo-prevent-body-scrolling` que Klaviyo
        deja pegada al <body> y bloquea el scroll de la pagina.
        ESE ES EL BUG GORDO QUE ESTE FICHERO EXISTE PARA TAPAR:
        sin esto la clienta se queda sin poder hacer scroll.

   ⚠️ POR QUE PETABA: `vigilar()` se llama desde un setInterval que
   arranca en cuanto el script se ejecuta, y tocaba `document.body`
   sin comprobar que existiera. En las primeras vueltas del intervalo
   — mientras Shopify todavia esta montando la pagina — `body` puede
   ser null y reventaba. No rompia nada visible, pero llenaba la
   consola de errores y dejaba el ciclo a medias, asi que la clase
   del scroll tardaba mas en quitarse de lo que deberia.

   ⚠️ REGLA PARA EL FUTURO: en este fichero TODO acceso al DOM va
   guardado. Se ejecuta en un intervalo desde antes de que la pagina
   este montada; aqui no se puede dar nada por hecho.
   ============================================================ */
(function () {
  if (window.__pnKlaviyo) return;
  window.__pnKlaviyo = true;

  var CSS = [
    'html.pn-tpl-product [class*="kl-teaser"]{display:none !important}',
    'html.pn-consentimiento div[class*="kl-private-reset-css"]{display:none !important}'
  ].join('');

  var estilo = document.createElement('style');
  estilo.textContent = CSS;
  (document.head || document.documentElement).appendChild(estilo);

  function marcarPlantilla() {
    var raiz = document.documentElement;
    if (!raiz) return;
    var main = document.querySelector('main[data-template]');
    var tpl = main ? main.getAttribute('data-template') : '';
    if (!tpl) return;
    /* Las plantillas alternativas llegan como "product.calzado". El punto
       es legal en classList pero luego no se puede seleccionar en CSS,
       asi que se parte y se marca solo la familia: pn-tpl-product. */
    var familia = String(tpl).split('.')[0].trim();
    if (familia) raiz.classList.add('pn-tpl-' + familia);
  }

  function bannerCookiesVisible() {
    var b = document.querySelector('#shopify-pc__banner');
    if (!b) return false;
    var cs = getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return b.getBoundingClientRect().height > 0;
  }

  function modalKlaviyoVisible() {
    var nodos = document.querySelectorAll('div[class*="kl-private-reset-css"]');
    for (var i = 0; i < nodos.length; i++) {
      var n = nodos[i];
      if (String(n.className).indexOf('kl-teaser') !== -1) continue;
      var r = n.getBoundingClientRect();
      if (r.width > 200 && r.height > 200) {
        var cs = getComputedStyle(n);
        if (cs.display !== 'none' && cs.visibility !== 'hidden') return true;
      }
    }
    return false;
  }

  function vigilar() {
    var raiz = document.documentElement;
    var body = document.body;
    if (!raiz || !body) return;          /* <-- la guarda que faltaba */

    var conBanner = bannerCookiesVisible();
    raiz.classList.toggle('pn-consentimiento', conBanner);

    if (!body.classList.contains('klaviyo-prevent-body-scrolling')) return;
    if (conBanner || !modalKlaviyoVisible()) {
      body.classList.remove('klaviyo-prevent-body-scrolling');
      if (getComputedStyle(body).overflow === 'hidden') {
        body.style.setProperty('overflow', 'visible', 'important');
      }
    }
  }

  function arrancar() {
    marcarPlantilla();
    vigilar();
    setInterval(vigilar, 800);
    document.addEventListener('click', function () { setTimeout(vigilar, 120); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
